import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import GestionSaisieDepenses from "./GestionSaisieDepenses";
import ExpensesMobile from "../mobile/depenses/ExpensesMobile";

export default function ResponsiveGestionSaisieDepenses(props) {
  return useIsMobile() ? <ExpensesMobile {...props} /> : <GestionSaisieDepenses {...props} />;
}
